// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3Wwjp","text":"SelectPayment_text__dNm7k","title":"SelectPayment_title__x7kHA","btn":"SelectPayment_btn__1_L47"};